import { ApiService } from 'services';

import { handleException } from 'actions/exceptions';

export const GET_SPECIALRATEPROVISIONS_SUCCESS = 'GET_SPECIALRATEPROVISIONS_SUCCESS';
export const GET_SPECIALRATEPROVISIONS_CLEAR = 'GET_SPECIALRATEPROVISIONS_CLEAR';

function receive(specialRateProvisions) {
  return {
    type: GET_SPECIALRATEPROVISIONS_SUCCESS,
    specialRateProvisions
  };
}

function clear() {
  return {
    type: GET_SPECIALRATEPROVISIONS_CLEAR
  };
}

export function getSpecialRateProvisions(treatCountry, lobProvisions) {
  return (dispatch) => {
    const hasPensionClaim = lobProvisions && lobProvisions.length === 1 && lobProvisions.includes('2');
    const promise = () => ApiService
      .getSpecialRateProvisions(treatCountry, hasPensionClaim)
      .then((response) => {
        dispatch(receive(response.data));
      }).catch((error) => {
        if (!error.response) {
          ApiService.addQueuedPromise(promise, error);
        } else if (error.retries && error.retries > 1) {
          dispatch(handleException(error, clear, false));
        }
      });
    return promise();
  };
}

export function clearSpecialRateProvisions() {
  return dispatch => dispatch(clear());
}
